import useSWRImmutable from 'swr'
import fetcher from './fetcher'

export default function useEsgScore(stockId) {
  const { data, error, isLoading } = useSWRImmutable(
    stockId ? `/react/esg_score?stock_id=${stockId}` : null,
    fetcher,
  )

  return {
    esg_score: data,
    isLoading,
    error
  }
}